<template>
    <div class="bg-white mt-3 p-3 progress-status-view activity-type-create col-12">
        <div class="d-flex title-bar-block mb-2">
            <div class="icon-block me-3">
                <button v-b-tooltip.hover :title="$backLabel()" id="cancel-label-btn" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ $translate('bill_payment_to') }}</span>
            </div>
        </div>

        <b-overlay :show="loading" rounded="sm">
            <b-form class="form-sample" @submit.stop.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-username-bpt"><strong>{{ $translate('username') }}</strong><span
                                class="red">*</span></label>
                        <b-form-input class="form-control" id="input-username-bpt" v-model="model.username"
                            :placeholder="$translate('email')" type="email">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-password-bpt"><strong>{{ $translate('password') }}</strong><span
                                class="red">*</span></label>
                        <b-input-group class="password-field-container">

                            <b-form-input class="form-control" id="input-password-bpt" v-model="model.password"
                                :placeholder="$translate('password')" :type="showPassword ? 'text' : 'password'">
                            </b-form-input>
                            <b-input-group-append class="eye-btn">
                                <i @click="showPassword = !showPassword"
                                    :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>

                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-encryption-bpt"><strong>{{ $translate('encryption')
                                }}</strong><span class="red">*</span></label>
                        <b-form-input class="form-control" id="input-encryption-bpt" v-model="model.encryption"
                            :placeholder="'ssl or tls'" type="text">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-host-bpt"><strong>{{ $translate('host') }}</strong><span
                                class="red">*</span></label>
                        <b-form-input class="form-control" id="input-host-bpt" v-model="model.host"
                            :placeholder="'imap.gmail.com'" type="text">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-port-bpt"><strong>{{ $translate('port') }}</strong><span
                                class="red">*</span></label>
                        <b-form-input class="form-control" id="input-port-bpt" v-model="model.port"
                            :placeholder="$translate('port')" type="number">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-protocol-bpt"><strong>{{ $translate('protocol') }}</strong><span
                                class="red">*</span></label>
                        <b-form-input class="form-control" id="input-protocol-bpt" v-model="model.protocol"
                            :placeholder="$translate('protocol')" type="text">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label class="mb-3" for="input-default_account-bpt"><strong>{{ $translate('default_account')
                                }}</strong><span class="red">*</span></label>
                        <b-form-input class="form-control" id="input-default_account-bpt"
                            v-model="model.default_account" :placeholder="$translate('default_account')" type="text">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-3">
                        <label for="" style="visibility: hidden;height:30px;"></label>
                        <div class="form-check">
                            <label class="form-check-label lh-base">
                                <input type="checkbox" class="form-check-input top-2" id="validate_cert-bpt"
                                    v-model="model.validate_cert" name="validate_cert-bpt" :value="1"
                                    :unchecked-value="false" />
                                {{ $translate("validate_cert") }}
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </b-col>
                </b-row>
                <b-col md="12" class="mb-2 mt-3 text-center">
                    <b-button id="create-bill-payment-to-btn" class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionCreate && !model.id"
                        variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                    <b-button id="update-bill-payment-to-btn" class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionUpdate && model.id"
                        variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                    <b-button id="delete-bill-payment-to-btn" v-if="!!this.model.id && hasPermissionDelete" @click="deleteItem()" size="fw" class="me-2"
                        variant="delete-button">
                        {{ $translate('delete_item') }}
                    </b-button>
                    <b-button id="cancel-bill-payment-to-btn" variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">{{
                        $cancelLabel() }}</b-button>
                </b-col>
            </b-form>
        </b-overlay>

    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'BillPaymentTo-ViewItem',
    mixins: [popupMixins, permissionsMixins],
    components: {

    },
    data() {
        return {
            showPassword: false,
            model: {
                id: 0,
                username: null,
                password: null,
                host: null,
                encryption: null,
                port: 993,
                validate_cert: true,
                default_account: 'Default',
                protocol: 'imap',
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            console.log(this.user_permissions)
            return !this.model.id
        },
        /**
         * True if the user has permission to view but not update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canView() {
            return !!this.model.id
        },
        /**
         * True if the user has permission to update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canUpdate() {
            return !!this.model.id
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {},
    async mounted() {
        if (this.item.id) {
            this.model = this.item
            if (this.item.password) {
                this.$set(this.model, 'password', atob(this.item.password))
            }
        }
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }

            if (model.password) model.password = btoa(model.password);

            console.log('model', model)
            const action = model.id ? 'update' : 'create'
            const message = model.id ? this.$translate('update_alert') : this.$translate('create_alert')
            const path = `billPaymentTo/${action}`
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            this.$emit(
                                'success',
                                action,
                                message
                            )
                        })
                        .catch(error => {
                            console.log('error', error)
                            this.$emit('error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'billPaymentTo/delete'
            const action = model.id ? 'update' : 'create'

            // Generate and display confirmation prompt
            const title = this.$translate('delete_bill_payment_to')
            const message = `${this.$translate('delete_note')} ${model.username}?`
            // const errorMsg = 'Unable to delete Progress Status!'
            const alertMsg = this.$translate('delete_alert')
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                action,
                                alertMsg
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
        },
        adjustMultiselectHeight() {

            setTimeout(() => {

                const minHeight = 10;
                const wrappersel = document.querySelector('.multiselect__tags-wrap');
                if (!wrappersel) return;
                const calculatedHeight = minHeight + wrappersel.offsetHeight;
                console.log('wrappersel.style.height', wrappersel.offsetHeight, calculatedHeight)

                // const multiselectEl = document.querySelector('.multiselect');
                const tagsel = document.querySelector('.multiselect__tags');
                if (tagsel) {
                    // multiselectEl.style.height = `${calculatedHeight}px`;
                    tagsel.style.height = `${calculatedHeight}px`;
                }
            }, 200);
        }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>
